import React from 'react'
import MyPayroll from './MyPayroll'


export default function TCIssueReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
